import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { TransportOrderCatalogState, TransportOrderCatalogStateModel } from './transport-order-catalog.state';
import { TransportOrderCatalogInitialState, TransportOrderCatalogLoad } from './transport-order-catalog.actions';
import { SetInitialStateFacade } from '../../../../../../common/models';
import { TransportCatalogSearchCriteria, TransportOrderPrimary } from '../../models';

@Injectable({ providedIn: 'root' })
export class TransportOrderCatalogFacade implements SetInitialStateFacade {
  listDto$: Observable<TransportOrderCatalogStateModel> = this.store.select(TransportOrderCatalogState.getState);
  items$: Observable<TransportOrderPrimary[]> = this.store.select(TransportOrderCatalogState.getItems);
  loaded$: Observable<boolean> = this.store.select(TransportOrderCatalogState.getLoaded);

  constructor(private store: Store) {}

  load(searchCriteria: Partial<TransportCatalogSearchCriteria>): void {
    this.store.dispatch(new TransportOrderCatalogLoad(searchCriteria));
  }

  setInitialState(): void {
    this.store.dispatch(new TransportOrderCatalogInitialState());
  }
}
